import {
  defaultCellRenderer,
  getAging,
  defaultGroupRenderer as groupRenderer,
  generateMultiFilterConfigFromModel, columnAvatarRenderer
} from "../utils/utils.jsx";
import {WIDGET_KEYS} from "./WidgetKeys.jsx";
import {DateHelper} from "@bryntum/schedulerpro";
import {
  cellMenuItemCollapseAllRows,
  cellMenuItemCollapseRow, cellMenuItemRemoveRow,
  entitySendBoardAlert
} from "../utils/gridCellMenuUtils.jsx";
import {SWIVU_GROUP_CONTEXT_MENU_SELECTOR} from "./OtherKeys.jsx";
import { User } from "../../bryntum-lib/models/User.jsx";

const USER_VIEW_FILTER_FIELD_CONFIG = {
  ...generateMultiFilterConfigFromModel(User),
  roleName: { type: "_swivu_settings" }
};

export const ScheduleUserConfig = {
  minHeight: "30em",
  height: "100%",
  flex: 1,
  filterFeature: {
    pickerConfig: {
      fields: USER_VIEW_FILTER_FIELD_CONFIG
    },
    closeEmptyPopup: true
  },
  cellMenuFeature: {
    clickTriggerSelector: SWIVU_GROUP_CONTEXT_MENU_SELECTOR,
    items: {
      cut: false,
      copy: false,
      paste: false,
      filterStringEquals: false,
      filterDisable: false,
      removeRow: cellMenuItemRemoveRow(),
      collapseRow: cellMenuItemCollapseRow(),
      collapseAllRows: cellMenuItemCollapseAllRows(),
      entitySendBoardAlert: entitySendBoardAlert()
    }
  },
  rowExpanderFeature: {
    column: {
      hidden: true,
    },
    /* We have to keep empty renderer as this renderer is changed dynamically from the @UserPage.jsx file, if we don't keep this function here it does not work */
    renderer: () => {}
  },
  selectionModeFeature: {
    multiSelect: false,
  },
  groupFeature: "roleName",
  listeners: {
    // These listeners are being triggered from row expander
    rowExpand(e) {
      e.record.isGridRowExpanded = true;
    },
    rowCollapse(e) {
      e.record.isGridRowExpanded = false;
    }
  },
  columns: [
    {
      id: "id",
      field: "id",
      text: "User Id",
      editor: false,
      maxWidth: "8em",
      renderer: defaultCellRenderer,
      groupRenderer,
      flex: 1,
      filterable: false,
      afterRenderCell({ cellElement, record }) {
        if (record.isPhantom) {
          cellElement.innerText = defaultCellRenderer({ value: null});
        }
      }
    },
    {
      id: "contactButton",
      type: WIDGET_KEYS.contactColumn
    },
    {
      id: "name",
      field: "name",
      text: "Name",
      // Todo: Use EntityMainNameColumn
      type: WIDGET_KEYS.swivuSortColumn,
      cellCls: 'flex gap-[0.5em]',
      renderer: ({ record, grid }) => (columnAvatarRenderer({
        image: record.profileImageURL,
        name: record.name,
        archived: record.archived,
        size: grid.rowHeight
      })),
      groupRenderer,
      flex: 1,
      editor: false,
    },
    {
      id: "email",
      field: "email",
      text: "Email",
      type: WIDGET_KEYS.swivuSortColumn,
      editor: WIDGET_KEYS.fieldEmail,
      cellCls: "swivu-copy-icon-cell",
      renderer: ({ value }) => {
        const dataset = (v) => ({
          id: v.id,
          type: v.type,
        });

        const icon = value ? {
          tag: "i",
          class: "fa-thin fa-copy cursor-pointer dark:text-[#ffffff] text-[#000000] transition-colors duration-300 ease-in-out hover:opacity-70",
          dataset: dataset({ id: "email", type: "iconType" }),
        } : "";

        return [
          {
            tag: "span",
            text: defaultCellRenderer({ value }),
            class: "mr-[0.5em]",
          },
          icon
        ]
      },
      groupRenderer,
      flex: 1,
    },
    {
      id: "role",
      type: WIDGET_KEYS.userRoleColumn,
      field: "roleName",
    },
    { type: WIDGET_KEYS.swivuUserGrantViewButtonColumn },
    { type: WIDGET_KEYS.swivuUserOwnershipColumn },
    {
      id: "user-aging",
      text: "Age",
      field: "aging",
      flex: 1,
      editor: false,
      filterable: false,
      type: "agingColumn",
      groupRenderer({ groupRowFor, count }) {
        return groupRowFor ? groupRenderer({ groupRowFor: DateHelper.formatCount(getAging(groupRowFor), 'day'), count }): defaultCellRenderer({ value: null });
      }
    },
    {
      id: "user-last-interaction-hq",
      text: "Last Interaction HQ",
      field: "lastInteractionHQ",
      flex: 1,
      filterable: false,
      editor: false,
      renderer(e) {
        return e.value ? DateHelper.format(new Date(e.value), 'MM/DD/YYYY hh:mm A'): defaultCellRenderer({ value: null });
      },
      groupRenderer({ groupRowFor, count }) {
        return groupRowFor ? groupRenderer({ groupRowFor: DateHelper.format(new Date(groupRowFor), 'MM/DD/YYYY hh:mm A'), count }): defaultCellRenderer({ value: null });
      }
    },
    {
      id: "user-last-interaction-workforce",
      text: "Last Interaction Workforce",
      field: "lastInteractionWorkforce",
      flex: 1,
      filterable: false,
      editor: false,
      renderer(e) {
        return e.value ? DateHelper.format(new Date(e.value), 'MM/DD/YYYY hh:mm A'): defaultCellRenderer({ value: null });
      },
      groupRenderer({ groupRowFor, count }) {
        return groupRowFor ? groupRenderer({ groupRowFor: DateHelper.format(new Date(groupRowFor), 'MM/DD/YYYY hh:mm A'), count }): defaultCellRenderer({ value: null });
      }
    },
  ],
}
